var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManwebsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 8.16667V3.16667C15.6667 2.24583 14.9208 1.5 14 1.5H3.16667C2.24583 1.5 1.5 2.24583 1.5 3.16667V14.8333C1.5 15.7542 2.24583 16.5 3.16667 16.5H7.33333",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2891 16.2558L16.2558 13.2892C16.5816 12.9633 16.5816 12.4358 16.2558 12.1108L14.9341 10.7892C14.6083 10.4633 14.0808 10.4633 13.7558 10.7892L10.7891 13.7558C10.6325 13.9125 10.545 14.1242 10.545 14.345V16.5H12.7C12.9208 16.5 13.1325 16.4125 13.2891 16.2558Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85417 3.575C3.85167 3.575 3.85 3.57667 3.85 3.57917C3.85 3.58167 3.85167 3.58333 3.85417 3.58333C3.85667 3.58333 3.85833 3.58167 3.85833 3.57917C3.85833 3.57667 3.85667 3.575 3.85417 3.575",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97331 3.575C5.97081 3.575 5.96914 3.57667 5.96914 3.57917C5.96914 3.58167 5.97164 3.58333 5.97331 3.58333C5.97581 3.58333 5.97747 3.58167 5.97747 3.57917C5.97747 3.57667 5.97581 3.575 5.97331 3.575",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08915 3.575C8.08665 3.575 8.08499 3.57667 8.08499 3.57917C8.08499 3.58167 8.08665 3.58333 8.08915 3.58333C8.09165 3.58333 8.09332 3.58167 8.09332 3.57917C8.09332 3.57667 8.09165 3.575 8.08915 3.575",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53833 5.66667H15.6667",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManwebsvg);
export default __webpack_public_path__ + "static/media/manwebsvg.83a63021799697bae3522cbe05a67eb2.svg";
export { ForwardRef as ReactComponent };